<p-toast />
<p-confirmDialog />

<section class="w-full md:p-3">
  <app-content-card title="Papelera">
    <p class="m-0 mb-3 text-sm text-color-secondary">
      Personas que fueron eliminadas. Se pueden restaurar o borrar del sistema.
    </p>

    <div class="border-1 surface-border border-round overflow-hidden bg-white">
      <div class="px-3 py-2 border-bottom-1 surface-border">
        <p-iconfield iconPosition="left" class="w-full md:w-20rem">
          <p-inputicon [styleClass]="esperandoBusqueda() ? 'pi pi-spinner pi-spin' : 'pi pi-search'" />
          <input
            pInputText
            type="text"
            class="w-full p-inputtext-sm"
            placeholder="Buscar por nombre..."
            [ngModel]="busqueda()"
            (ngModelChange)="onSearchInput($event)"
            [attr.aria-busy]="esperandoBusqueda()"
            autocomplete="off"
            aria-label="Buscar en la papelera"
          />
        </p-iconfield>
      </div>

      <app-person-table
        [rows]="rows()"
        [columns]="columnas"
        [loading]="loading()"
        [paginator]="totalRecords() > pageSize"
        [rowsPerPage]="pageSize"
        [lazy]="true"
        [totalRecords]="totalRecords()"
        [first]="first()"
        [filtro]="'papelera'"
        [emptyMessage]="vacio()"
        (pageChange)="onTablePageChange($event)"
        (menuAction)="onMenu($event)"
      />
    </div>
  </app-content-card>
</section>
